import React from 'react';
import json2csv from 'json2csv';

export function formatHours(totalMinutes){
    if(!totalMinutes) return "";

    const hours = totalMinutes / 60;
    const fullHours = Math.floor(hours);
    const minutes = ("0" + parseInt(Math.max(0, totalMinutes - fullHours * 60), 10)).slice(-2);
    return <span className="styled-hours">
        {fullHours}
        <span className="hours">
            hr
        </span>
        {minutes}
        <span className="minutes">
            min
        </span>

    </span>;
}

export function formatHoursAsString(totalMinutes){
    if(!totalMinutes) return "";

    const hours = totalMinutes / 60;
    const fullHours = Math.floor(hours);
    const minutes = ("0" + parseInt(Math.max(0, totalMinutes - fullHours * 60), 10)).slice(-2);
    return fullHours + " hr " + minutes + " min";
}

export function formatHoursAsObject(totalMinutes){
    if(!totalMinutes) return "";

    const hours = totalMinutes / 60;
    const fullHours = Math.floor(hours);
    const minutes = ("0" + parseInt(Math.max(0, totalMinutes - fullHours * 60), 10)).slice(-2);
    return {hours: fullHours, minutes: minutes};
}

export function exportEntries(name, entryArray, tasks, users, clients, projects){

    const exportArray = entryArray.reduce((entries, entry) => {
        entries.push({
            date: entry.date,
            minutes: entry.minutes,
            task : tasks.items[entry.task.id] ? tasks.items[entry.task.id].name : "unknown",
            budget: tasks.items[entry.task.id] ? tasks.items[entry.task.id].budgetMinutes : "unknown",
            user: users.items[entry.user.id] ? users.items[entry.user.id].name : "unknown",
            client: clients.items[entry.client.id] ? clients.items[entry.client.id].name : "unknown",
            project: projects.items[entry.project.id] ? projects.items[entry.project.id].name : "unknown",
            description : entry.description,
            created: entry.createdAt,
        });
        return entries;
    }, []);

    exportArray.sort((a,b) => b.date - a.date);

    const csv = json2csv({
        data: exportArray,
        fields: [
            "date",
            "client",
            "project",
            "task",
            "minutes",
            "budget",
            "user",
            "description",
            "created"
        ]
    });

    download(name, csv);
}

export function download(fileName, data){
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(data));
    element.setAttribute('download', fileName);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

export function needsSetup(state) {
    return (state.clients.fetched && Object.values(state.clients.items).length === 0)
        || (state.projects.fetched && Object.values(state.projects.items).length === 0)
        || (state.tasks.fetched && Object.values(state.tasks.items).length === 0)
}


// WEBPACK FOOTER //
// ./src/utils.js